import { BaseTooltipModel } from "./base-tooltip-model";

export class TextModel extends BaseTooltipModel {
    init(classList, id, tag) {
        this.product || (this.product = this.createElement(null != tag ? tag : "span", classList, void 0, id));
    }
    setContent(content, multiLine) {
        if (!this.product) return;
        let html = this._option.valueToHtml(content);
        multiLine && (html = html.replaceAll("\n", "<br>")), html !== this.product.innerHTML && (this.product.innerHTML = html);
    }
}
//# sourceMappingURL=text-model.js.map
